import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import * as React from "react";
import { Link } from "react-router-dom";
import { pr } from "aaa";
export class GlobalHeader extends React.Component<{}, {}> {

    // tslint:disable-next-line:max-func-body-length
    render() {
        return (
            <div>

                <style>{`
                    @media screen and (max-width: 749px) {
                        .appBar {
                            display: none;
                        }
                    }
                    @media screen and (min-width: 750px) {
                        .mobileAppBar {
                            display: none;
                        }z
                    }
                `}</style>

                <div
                    style={{
                        background: "#fff3cd",
                        borderBottom: "1px solid #ffc107",
                        padding: "12px 20px",
                        textAlign: "center",
                        fontFamily: "Arial, sans-serif",
                        fontSize: 14,
                        color: "#856404",
                    }}
                >
                    Im Moment ist das Absenden des Anfrageformulars nicht möglich. Wir arbeiten an der Behebung des Problems. Entschuldigen Sie die Unannehmlichkeiten.
                    <br />
                    Gern können Sie uns während der Filialservicezeiten telefonisch unter 069/7537-20720 erreichen.
                </div>

                <div
                    className={"appBar"}
                    style={{
                        marginBottom: 10,
                        boxShadow: "0px 1px 10px 0px rgba(0, 0, 0, 0.2)",
                        background: "white"
                    }}
                >
                    <pr.HFlexCentered>
                        <div style={{ width: 800, height: 60, paddingTop: 20 }}>
                            <Toolbar style={{ paddingLeft: 0, paddingRight: 0, backgroundColor: "white" }}>
                                <Link to="/">
                                    <img src={require("../assets/sparda-bank-logo.svg")} alt="sparda-bank-logo" width="200" />
                                </Link>
                                <div style={{ flex: 1, marginTop: 15 }}>
                                    <span style={{ marginLeft: 40, fontFamily: "Arial,sans-serif", fontSize: 13, color: "black" }}>Sparda-Bank Hessen eG</span>
                                </div>
                                <div>
                                    <img style={{ verticalAlign: "middle" }} src={require("../assets/ssl-icon.png")} alt="ssl-icon" width="42" />
                                    <span
                                        style={{
                                            verticalAlign: "middle",
                                            color: "#09851e",
                                            fontSize: ".75em",
                                            display: "inline-block",
                                            paddingLeft: 10,
                                            fontFamily: "Arial, sans-serif"
                                        }}
                                    >
                                        Sichere Datenübermittlung <br /> durch Verschlüsselung
                                    </span>
                                </div>
                            </Toolbar>
                        </div>
                    </pr.HFlexCentered>
                    {/*</AppBar>*/}
                </div>
                <div className={"mobileAppBar"} style={{ lineHeight: "80px", textAlign: "center" }}>
                    <img src={require("../assets/sparda-bank-logo.svg")} alt="sparda-bank-logo" width="200" style={{ verticalAlign: "middle", marginRight: -62 }} />
                    <img style={{ verticalAlign: "middle", float: "right", marginTop: 20, marginRight: 20 }} src={require("../assets/ssl-icon.png")} alt="ssl-icon" width="42" />
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/GlobalHeader.tsx